import React from 'react';
import IconPlayCircle from '@/assets/icons/icon-play-circle.svg?react';
import { SecondaryButton } from '@/components/buttons/SecondaryButton/SecondaryButton';
import IconDelete from '@/assets/icons/icon-delete.svg?react';
import clsx from 'clsx';

interface VideoPreviewProps {
  thumbnailUrl?: string | null;
  onClearClick?: () => void;
}

export const VideoPreview: React.FC<VideoPreviewProps> = ({
  thumbnailUrl = null,
  onClearClick,
}) => {
  return (
    <div
      className={clsx(
        'group bg-neutral-10 relative inline-flex h-31 w-54 cursor-pointer flex-col items-center justify-center gap-2.5 rounded px-12 py-4.5 outline outline-offset-[-1px] outline-neutral-100',
      )}
      data-testid="video-preview"
    >
      <div
        className={clsx('flex h-20 w-30 items-center justify-center overflow-hidden rounded-lg', {
          'outline-coral-500 bg-red-400/20 outline outline-offset-[-1px] outline-dashed':
            !thumbnailUrl,
        })}
        style={
          thumbnailUrl
            ? {
                backgroundImage: `url(${thumbnailUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }
            : undefined
        }
        data-testid="video-preview-thumbnail"
        data-thumbnail-url={thumbnailUrl || undefined}
      >
        {!thumbnailUrl && <IconPlayCircle className="text-coral-500 h-6 w-6" />}
        {thumbnailUrl && (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-500/80">
            <div className="ml-0.5 h-0 w-0 border-t-[5px] border-b-[5px] border-l-[8px] border-t-transparent border-b-transparent border-l-white" />
          </div>
        )}
      </div>

      {onClearClick && (
        <div className="absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center gap-2 rounded border border-indigo-500 bg-indigo-50 opacity-0 transition-all group-hover:opacity-100">
          <SecondaryButton text="Clear" size="sm" icon={IconDelete} onClick={onClearClick} />
        </div>
      )}
    </div>
  );
};
